import React from 'react';
import axios from 'axios';
import './App.css';
import {BrowserRouter, Switch, Router, Link} from 'react-router-dom';
import AppStoreBadge from './Assets/svgs/appStoreBadge.svg';
import GoogleplayBadge from './Assets/svgs/googlePlayBadge.svg';
class  Default extends React.Component {



  render() {
    return (
      <div className="App">
        <Link style={{textDecoration: "none"}} to='/'>
          <div className="header" >
          <p className="title">threads</p>
          <p className="tagLine">bringing you the best of twitter</p>
          </div>
        </Link>
        <div className="badges">
          <a href="https://apps.apple.com/in/app/threads/id1512677811">
            <div className="ctaBadge">
              <img src={AppStoreBadge} alt="App Store Download" />
            </div>
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.threadsapp">
            <div className="ctaBadge">
              <img src={GoogleplayBadge} alt="Google Play Download" />
            </div>
          </a>
        </div>
      </div>
    );
  }
}

export default Default;
